module.exports = __webpack_public_path__ + "img/xlsx.3d2b63f.svg";